module.exports = __webpack_public_path__ + "img/username.7d19e70d.svg";